import { TextField } from "@mui/material";
import React from "react";
import marital_status from "../api/maritalStatus";
import sexual_orientation from "../api/sexualOrientation";
import gender from "../api/gender";
import living_with from "../api/livingwith";
import nationalities from "../api/nationalities";
import countries from "../api/countries";
import relationship from "../api/relationship";
import addictions from "../api/addictions";
import allergies from "../api/allergies";
import drugallergies from "../api/drugallergies";
import aftercareStaff from "../api/aftercareStaff";
import ids from "../api/intendedDurationOfStay";
import groupType from "../api/groupType";
import dummyClients from "../api/dummyClients";
import dischargeType from "../api/dischargesType";
import dischargeTo from "../api/dischargeTo";
import treatmentType from "../api/treatmentType";
import treatmentOutcome from "../api/treatmentOutcome";
import substances from "../api/substances";
import route from "../api/route";
import roles from "../api/roles";
import clientStatus from "../api/clientStatus";
import durationOfStay from "../api/durationOfStay";
import "../css/inputs/Dropdown.css";
import pendingReceived from "../api/pendingReceived";
import pendingBooked from "../api/pendingBooked";
import paymentDetails from "../api/paymentDetails";
import status2 from "../api/status2";
import daysOfWeek from "../api/DaysOfWeek";
import yesno from "../api/yesno";

export default function DropDownComponent(props) {
  const api = props.api;
  const apiData = {
    maritalStatus: marital_status,
    sexualOrientation: sexual_orientation,
    gender: gender,
    livingWith: living_with,
    nationalities: nationalities,
    countries: countries,
    relationship: relationship,
    addictions: addictions,
    allergies: allergies,
    drugallergies: drugallergies,
    ids: ids,
    aftercareStaff: aftercareStaff,
    groupType: groupType,
    dummyClients: dummyClients,
    dischargeType: dischargeType,
    dischargeTo: dischargeTo,
    treatmentType: treatmentType,
    treatmentOutcome: treatmentOutcome,
    substances: substances,
    route: route,
    roles: roles,
    clientStatus: clientStatus,
    durationOfStay: durationOfStay,
    pendingReceived: pendingReceived,
    pendingBooked: pendingBooked,
    paymentDetail: paymentDetails,
    status2: status2,
    daysOfWeek: daysOfWeek,
    yesno: yesno,
  };

  const options = apiData[api];

  const handleChange = (event) => {
    props.onChange(event.target.value);
  };

  const isFieldEmpty = (value) => {
    return value === "" || value === null || value === undefined;
  };

  const renderOptions = () => {
    const getOptionLabel = (option) =>
      props.displayInHouseAsActive &&
      api === "clientStatus" &&
      option.textDropDownEn === "In House"
        ? "Active"
        : option.textDropDownEn;

    if (props.level === "2") {
      const category = options.find(
        (option) => option.textDropDownEn === props.mainSubstance
      );
      if (category && category.subcategories) {
        return category.subcategories
          .sort((a, b) => a.textDropDownEn.localeCompare(b.textDropDownEn))
          .map((sub) => (
            <option key={sub.id} value={sub.textDropDownEn}>
              {getOptionLabel(sub)}
            </option>
          ));
      }
    } else {
      return options
        .sort((a, b) => a.textDropDownEn.localeCompare(b.textDropDownEn))
        .map((option) => (
          <option key={option.id} value={option.textDropDownEn}>
            {getOptionLabel(option)}
          </option>
        ));
    }
  };

  return (
    <div className="input-label-container">
      <div className="input-label-dropdown">
        {props.title}{" "}
        {props.isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
      <TextField
        className="dropdown-select"
        SelectProps={{
          native: true,
          style: { height: 40 },
        }}
        select
        value={props.value}
        onChange={handleChange}
        style={{
          border:
            props.showValidation && isFieldEmpty(props.value)
              ? "1px solid red"
              : "none", // Bordure rouge si vide
        }}
        error={props.showValidation && isFieldEmpty(props.value)} // Affiche l'erreur
        helperText={
          props.showValidation && isFieldEmpty(props.value)
            ? "This field is required."
            : ""
        }
      >
        {renderOptions()}
      </TextField>
    </div>
  );
}
